import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AreaOutput',
  props: {
    input: null,
    empty: {
      default: 'Неизвестно'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var label = computed(function () {
      return props.input.toLocaleString();
    });
    return {
      __sfc: true,
      props: props,
      label: label
    };
  }
});